/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { Row, Column } from '../../../styles/Grid';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import Spacer from '../../ui/Spacer';
import createButtonCss from '../../ui/Button/Button';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerMarginCss,
  containerPaddingCss,
  showMoreContainerCss,
  seeLessMoreCss,
} from './index.styles';

const defaultData = {
  fields: { BackgroundColor: {} },
  rendering: { placeholders: {} },
};

const getAccordionSections = () =>
  document.querySelectorAll(`[data-item="accordion-section"]`);

export class Accordion extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      displayShowMore: false,
      accordionSections: null,
    };
  }

  expand() {
    this.setState({ isExpanded: !this.state.isExpanded }, () => {
      this.validateSections();
    });
  }

  validateSections() {
    let { accordionSections } = this.state;
    if (this.state.displayShowMore && !this.state.isExpanded) {
      if (accordionSections) {
        accordionSections = accordionSections.map((section, i) => {
          if (i >= 3) {
            section.style.display = 'none';
          }
          return section;
        });
      }
    } else if (this.state.isExpanded) {
      if (accordionSections) {
        accordionSections = accordionSections.map((section, i) => {
          if (i >= 3) {
            section.style.display = 'block';
          }
          return section;
        });
      }
    }
    this.setState({ accordionSections });
  }

  updateDimensions = () => {
    if (window.innerWidth < 768) {
      this.setState({ isExpanded: false, displayShowMore: true }, () => {
        this.validateSections();
      });
    } else {
      this.setState({ isExpanded: true, displayShowMore: false }, () => {
        this.validateSections();
      });
    }
  };

  componentDidMount() {
    const accordionSections = Array.from(getAccordionSections());
    window.addEventListener('resize', this.updateDimensions);
    this.setState({ accordionSections }, () => {
      this.updateDimensions();
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  safeRender() {
    const { isExpanded, displayShowMore } = this.state;
    const { t } = this.props;
    const fields = get(this.props, 'fields', defaultData.fields);
    const hideSpacer = get(fields, 'hideSpacer', false);
    const IconSelection = get(fields, 'IconSelection.value', '');

    if (hideSpacer) {
      return (
        <React.Fragment>
          <Placeholder
            name="jss-accordion"
            rendering={this.props.rendering}
            params={{ hideSpacer, IconSelection }}
          />
          {displayShowMore && (
            <Row css={showMoreContainerCss}>
              <Column cols={{ sm: 8 }}>
                <button
                  onClick={() => this.expand()}
                  css={[createButtonCss('secondary'), seeLessMoreCss]}
                >
                  {isExpanded ? t('SeeLessCTA') : t('SeeMoreCTA')}
                </button>
              </Column>
            </Row>
          )}
        </React.Fragment>
      );
    }

    return (
      <Spacer
        backgroundColor={fields.BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Placeholder name="jss-accordion" rendering={this.props.rendering} />
        {displayShowMore && (
          <Row css={showMoreContainerCss}>
            <Column cols={{ sm: 8 }}>
              <button
                onClick={() => this.expand()}
                css={createButtonCss('secondary')}
              >
                {isExpanded ? t('SeeLessCTA') : t('SeeMoreCTA')}
              </button>
            </Column>
          </Row>
        )}
      </Spacer>
    );
  }
}

Accordion.displayName = 'Accordion';

Accordion.defaultProps = {
  t: key => key,
};

Accordion.propTypes = {
  fields: PropTypes.shape({
    BackgroundColor: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default withNamespaces()(Accordion);
